<h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="error"></esl-message-toast>
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            </div>
         <!--Laboratory form  -->
       

         <div class="ui form" [formGroup]="companyTccRecordForm">

                <div class="field" [ngClass]="displayFieldCss('year')">
                  <label>Year</label>
                                    <input  formControlName="year" type="text" placeholder="Year">
                  <app-field-error-display [displayError]="isFieldValid('year')" errorMsg="Please enter year">
                  </app-field-error-display>
            </div>

                  <div class="field" [ngClass]="displayFieldCss('totalProfit')">
                  <label>Total Profit</label>
                                    <input  formControlName="totalProfit" type="text" placeholder="Total Profit">
                  <app-field-error-display [displayError]="isFieldValid('totalProfit')" errorMsg="Please enter total profit">
                  </app-field-error-display>
            </div>
                 
            <div class=" field" [ngClass]="displayFieldCss('assessableProfit')">
                  <label>Accessible Profit</label>
                  <input  formControlName="assessableProfit" type="text" placeholder="Accessible Profit">
                        <app-field-error-display [displayError]="isFieldValid('assessableProfit')" errorMsg="Please enter assessable Profit">
                  </app-field-error-display>
                        </div>

                      <div class=" field" [ngClass]="displayFieldCss('turnOver')">
                  <label>Turn over</label>
                  <input  formControlName="turnOver" type="text" placeholder="Turn over">
                        <app-field-error-display [displayError]="isFieldValid('turnOver')" errorMsg="Please enter turnOver">
                  </app-field-error-display>
                        </div>
                  

                   <div class="field" [ngClass]="displayFieldCss('taxPaid')">
                       <label>Tax paid</label>
                       <input  formControlName="taxPaid" type="text" placeholder="Tax paid">
                         <app-field-error-display [displayError]="isFieldValid('taxPaid')" errorMsg="Please enter taxPaid">
                        </app-field-error-display>
                        </div>

                         
                                                      
                        
                                                            
                             

            




    </div>

 </div>
 </div>

      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Back</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="submit()" autofocus>Continue</button>

      </div>


